var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("tsp-summary-chart", {
        attrs: {
          value:
            _vm.filter === "future"
              ? _vm.futureTspSummary
              : _vm.todaysTspSummary,
        },
      }),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    This chart summarizes your TSP account based on the information you provided.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("tsp-summary-table", {
        attrs: {
          value:
            _vm.filter === "future"
              ? _vm.futureTspSummary
              : _vm.todaysTspSummary,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("more-info", {
            attrs: { moreInfo: _vm.moreInfo.tspSummary },
            on: { click: _vm.moreInfoOpen },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }